import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ManageUsers from '../pages/manage-user/ManageUsers';
import ProfileEditReview from '../pages/profile-edit-review/ProfileEditReview';
import EmployeeRegistration from '../pages/employee-registration/EmployeeRegistration';
import ConfirmUser from '../pages/confirm-user/ConfirmUser';
import AssignPermissions from '../pages/assign-permission/AssignPermissions';
import AssignPermissionsCDC from '../pages/assign-permission/AssignPermissionsCDC';
import UserType from '../pages/user-type/UserType';
import ParentCompany from '../pages/parent-company/ParentCompany';
import EditUserProfile from '../pages/edit-user-flow/EditUserProfile';
import MyProfile from '../pages/my-profile/MyProfile2';
import PermissionRoleContextProvider from '../components/Hooks/usePermissionRoles';
import FeatureFlagsContextProvider from '../components/Hooks/useFeatureFlags';
import ConfigConstantsContextProvider from '../components/Hooks/useConfigConstants';

const ProfileManageUserExternal = () => {
  return (
    <>
      <Routes>
        <Route index element={<ManageUsers />} />
        <Route path="parent-company" element={<ParentCompany />} />
        <Route path="user-type" element={<UserType />} />
        <Route path="emp-reg" element={<EmployeeRegistration />} />
        <Route path="edit-profile" element={<EditUserProfile />} />
        <Route path="permissions" element={<AssignPermissions createView={true} />} />
        <Route path="profile-review" element={<ProfileEditReview />} />
        <Route path="confirm-user" element={<ConfirmUser />} />
        <Route path="internal-permission" element={<AssignPermissionsCDC edit={false} />} />
        <Route path="my-profile" element={<MyProfile />} />
      </Routes>
    </>
  );
};

export default ProfileManageUserExternal;
